// extracted by mini-css-extract-plugin
export var cardIcon = "_7y-5";
export var cardIconUnframed = "_7y-9";
export var checkboxCard = "_7y-0";
export var checkboxCardSelected = "_7y-4";
export var disabled = "_7y-2";
export var interactive = "_7y-1";
export var outerBorder = "_7y-3";
export var spacerMedium = "_7y-8";
export var spacerSmall = "_7y-7";
export var spacerXsmall = "_7y-6";